/**
 * Quantity Breaks -> PDP Price fix (v2 - for theme versions without the
 * "Update displayed product page prices" toggle, e.g. 1.3.0).
 * Requires data-base-price to be added to the <quantity-breaks> tag in
 * snippets/quantity-breaks.liquid:
 *   data-base-price="{{ product.selected_or_first_available_variant.price }}"
 */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('quantity-breaks').forEach(function (qb) {
    var basePrice = parseFloat(qb.dataset.basePrice || '0'); // in cents
    if (!basePrice) return; // attribute not added yet, do nothing

    var sectionId = qb.dataset.section;
    var moneyFormat = qb.dataset.moneyFormat;

    var priceBlock = document.getElementById('price-' + sectionId);
    if (!priceBlock) return;

    var saleEl = priceBlock.querySelector('.price-item--sale');
    var regularEl = priceBlock.querySelector('.price-item--regular');
    var compareEl = priceBlock.querySelector('.price__compare-price .price-item--regular');
    var pctEl = priceBlock.querySelector('.badge__percentage-saved');
    var amtEl = priceBlock.querySelector('.badge__money-saved');

    function fmt(cents) {
      if (typeof window.formatMoney === 'function') {
        try {
          return window.formatMoney(cents, moneyFormat);
        } catch (e) {
          /* fall through to default formatter below */
        }
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function updateFromLabel(label) {
      if (!label) return;

      var qty = parseFloat(label.dataset.quantity || '1');
      var percentageLeft = parseFloat(label.dataset.percentageLeft || '1');
      var fixedDiscount = parseFloat(label.dataset.fixedDiscount || '0');
      // Real per-unit compare price (compare_at_price if on sale, else regular price),
      // rendered server-side in snippets/quantity-breaks.liquid via data-compare-price-each.
      var compareEach = parseFloat(label.dataset.comparePriceEach || basePrice);

      var totalPrice = basePrice * qty * percentageLeft - fixedDiscount;
      var totalCompare = compareEach * qty;

      if (saleEl) saleEl.textContent = fmt(totalPrice);
      if (regularEl) regularEl.textContent = fmt(totalPrice);
      if (compareEl) compareEl.textContent = fmt(totalCompare);

      if (totalCompare > totalPrice) {
        var pct = Math.floor(((totalCompare - totalPrice) * 100) / totalCompare);
        if (pctEl) pctEl.textContent = pct;
        if (amtEl) amtEl.textContent = fmt(totalCompare - totalPrice);
      }
    }

    function findLabelForInput(input) {
      return qb.querySelector('label[for="' + input.id + '"]');
    }

    qb.querySelectorAll('input[name="quantity"]').forEach(function (input) {
      input.addEventListener('change', function (e) {
        updateFromLabel(findLabelForInput(e.target));
      });
    });

    var checked = qb.querySelector('input[name="quantity"]:checked');
    if (checked) updateFromLabel(findLabelForInput(checked));
  });
});
